import { ResourceContext } from '@seddi/core';
import type { Button } from '@seddi/scene';
import type { ButtonLoader } from './buttonLoader';
import type { IBabylonButton } from './buttonTypes';

/**
 * Class for managing the loading and storage of buttons.
 */
export class ButtonsContext extends ResourceContext<IBabylonButton> {
  /** Button loader */
  private readonly buttonLoader: ButtonLoader;

  /**
   * Creates a new button resources context.
   * @param buttonLoader - Button loader.
   */
  constructor(buttonLoader: ButtonLoader) {
    super();
    this.buttonLoader = buttonLoader;
  }

  /**
   * Loads s button.
   * If the button is already loaded, returns a resolved promise.
   * If the button is currently being loaded, returns a promise that will be resolved when the button finishes loading.
   * @param button - Button to load.
   */
  public async loadEx(button: Button): Promise<void> {
    const resourceId = button.id;
    return super.load(
      resourceId,
      () => this.buttonLoader.loadAsync(button),
      (button: IBabylonButton) => this.buttonLoader.unload(button),
    );
  }
}
